import { useMemo } from "react";
import { formatNumber } from "@/utils/string";
import style from "./style.module.scss";

interface ProgressBarProps {
  value: number;
  total: number;
}

export default function ProgressBar({ value, total }: ProgressBarProps) {
  const computedPercent = useMemo(() => {
    if (!total || total <= 0) return 0;
    return Math.min(Math.max((value / total) * 100, 0), 100);
  }, [value, total]);

  return (
    <div className={style.wrapper}>
      <div
        className={style.progress}
        style={{ width: `${computedPercent}%` }}
      ></div>

      <span className={style.label}>
        Minted: {formatNumber(value)} / {formatNumber(total)}
      </span>
    </div>
  );
}
